/* Pace Pleasure: size explorer and sticky add-to-cart bar. */
(function () {
  'use strict';

  var SCALE = 2.5;   // px per mm in the drawing
  var CX = 230;      // centre line
  var BASE_Y = 362;  // ground line
  var PEAK_MID = 77.8; // mm from base, middle of the Peak zone (same on every plug, from CAD)
  var VALLEY_MID = 32.5;
  var BASE_TOP = 7.8; // height of the base flange (CAD); insertable length is measured from here
  var P5 = 31.4, P95 = 42.9; // erect girth percentiles as diameter, Veale et al. 2015

  function r1(v) { return Math.round(v * 10) / 10; }
  function mm(v) { return (Math.round(v * 10) / 10).toFixed(1) + ' mm'; }
  // Distance around a plug at its Peak, in cm. Every plug is perfectly round (checked on the CAD), so this is π × width.
  function around(p) { return Math.round(p.P * Math.PI) / 10; }

  function outlinePath(o) {
    if (!o || !o.p || !o.p.length) return '';
    var pts = o.p;
    var right = [], left = [];
    for (var i = 0; i < pts.length; i++) {
      right.push(r1(CX + pts[i][1] / 2 * SCALE) + ' ' + r1(BASE_Y - pts[i][0] * SCALE));
    }
    for (var j = pts.length - 1; j >= 0; j--) {
      left.push(r1(CX - pts[j][1] / 2 * SCALE) + ' ' + r1(BASE_Y - pts[j][0] * SCALE));
    }
    var b = pts[0][1] / 2 * SCALE;
    return 'M ' + r1(CX - b) + ' ' + BASE_Y + ' L ' + r1(CX + b) + ' ' + BASE_Y + ' L ' + right.join(' L ') +
      ' L ' + CX + ' ' + r1(BASE_Y - o.L * SCALE) + ' L ' + left.join(' L ') + ' Z';
  }

  class PaceSizeExplorer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.plugs = JSON.parse(this.querySelector('[data-pace-plugs]').textContent);
        this.outlines = JSON.parse(this.querySelector('[data-pace-outlines]').textContent);
      } catch (e) { return; }
      if (!this.plugs.length) return;
      this.q = function (sel) { return this.querySelector(sel); }.bind(this);
      this.strings = this.dataset;
      var self = this;
      this.querySelectorAll('[data-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.show(parseInt(btn.dataset.pick, 10)); });
      });
      var range = this.q('[data-range]');
      if (range) range.addEventListener('input', function () { self.show(parseInt(range.value, 10)); });
      var girth = this.q('[data-girth]');
      if (girth) girth.addEventListener('input', function () { self.find(girth.value); });
      var go = this.q('[data-find-go]');
      if (go) go.addEventListener('click', function () { if (self._found) self.show(self._found); });
      this.show(parseInt(this.dataset.initial || '1', 10));
    }

    show(n) {
      var i = Math.max(1, Math.min(this.plugs.length, n)) - 1;
      var p = this.plugs[i];
      var prev = i > 0 ? this.plugs[i - 1] : null;
      var o = this.outlines[String(p.n)] || this.outlines[String(i + 1)];
      var po = prev ? (this.outlines[String(prev.n)] || this.outlines[String(i)]) : null;
      var set = function (sel, attrs) {
        var el = this.q(sel); if (!el) return;
        Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
      }.bind(this);
      var txt = function (sel, t) { var el = this.q(sel); if (el) el.textContent = t; }.bind(this);

      set('[data-cur]', { d: outlinePath(o) });
      set('[data-prev]', { d: po ? outlinePath(po) : '', opacity: po ? 1 : 0 });
      var peakY = r1(BASE_Y - PEAK_MID * SCALE), valY = r1(BASE_Y - VALLEY_MID * SCALE);
      set('[data-peak-line]', { x1: r1(CX - p.P / 2 * SCALE), x2: r1(CX + p.P / 2 * SCALE), y1: peakY, y2: peakY });
      set('[data-val-line]', { x1: r1(CX - p.V / 2 * SCALE), x2: r1(CX + p.V / 2 * SCALE), y1: valY, y2: valY });
      set('[data-peak-label]', { x: r1(CX + p.P / 2 * SCALE + 14), y: r1(peakY + 5) });
      set('[data-val-label]', { x: r1(CX + p.V / 2 * SCALE + 14), y: r1(valY + 5) });
      txt('[data-peak-label]', (this.strings.peak || 'Peak') + ' ' + mm(p.P));
      txt('[data-val-label]', (this.strings.valley || 'Valley') + ' ' + mm(p.V));
      var len = o ? o.L : p.T;
      var tipY = r1(BASE_Y - len * SCALE), baseTop = r1(BASE_Y - BASE_TOP * SCALE);
      var brX = r1(CX - p.B / 2 * SCALE - 18);
      set('[data-br]', { x1: brX, x2: brX, y1: tipY, y2: baseTop });
      set('[data-br-top]', { x1: brX - 5, x2: brX + 5, y1: tipY, y2: tipY });
      set('[data-br-bottom]', { x1: brX - 5, x2: brX + 5, y1: baseTop, y2: baseTop });
      set('[data-br-label]', { x: brX - 10, y: r1((baseTop + tipY) / 2) });
      set('[data-br-label2]', { x: brX - 10, y: r1((baseTop + tipY) / 2 + 17) });
      txt('[data-br-label]', r1(p.I) + ' mm');
      txt('[data-ghost-note]', prev ? (this.strings.ghost || 'Dashed outline: plug') + ' ' + prev.n : '');
      var svg = this.q('[data-svg]');
      if (svg) svg.setAttribute('aria-label', 'Plug ' + p.n + ': Peak ' + mm(p.P) + ', Valley ' + mm(p.V) + ', ' + r1(p.I) + ' mm insertable');

      txt('[data-count]', (this.strings.plugWord || 'Plug') + ' ' + p.n + ' of ' + this.plugs.length);
      txt('[data-name]', p.name);
      txt('[data-desc]', p.desc);
      txt('[data-peak]', mm(p.P));
      txt('[data-around]', around(p).toFixed(1) + ' cm');
      txt('[data-valley]', mm(p.V));
      txt('[data-ins]', r1(p.I) + ' mm');
      var fill = function (tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); };
      var step = this.strings.first || 'The perfect place to start, whatever your experience.';
      if (prev) {
        step = fill(this.strings.stepTemplate || 'Peak {pct}% wider than plug {prev}. Its Valley is {gap} mm narrower than plug {prev}’s Peak.', { prev: prev.n, n: p.n, inc: r1(p.P - prev.P), gap: r1(prev.P - p.V), pct: Math.round((p.P - prev.P) / prev.P * 100) });
      }
      txt('[data-step]', step);
      txt('[data-firm]', p.F ? (this.strings.firmLabel || 'Feel') + ': ' + p.F : '');
      this.querySelectorAll('[data-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.dataset.pick, 10) === p.n));
      });
      var range = this.q('[data-range]'); if (range) range.value = String(i + 1);
      this.current = p.n;
    }

    find(value) {
      var msg = this.q('[data-find-msg]'), go = this.q('[data-find-go]');
      var g = parseFloat(String(value).replace(',', '.'));
      this._found = null;
      if (!(g > 0)) {
        if (msg) msg.textContent = msg.dataset.default || '';
        if (go) go.hidden = true;
        return;
      }
      // Circumference in, circumference out: match the measurement (cm around) to the distance around each plug's Peak.
      var cmIn = Math.round(g * 10) / 10, idx = -1;
      for (var k = 0; k < this.plugs.length; k++) { if (around(this.plugs[k]) >= cmIn) { idx = k; break; } }
      var first = this.plugs[0], last = this.plugs[this.plugs.length - 1], text;
      var fill = function (tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, key) { return map[key] != null ? map[key] : m; }); };
      var vars = function (p) { return { cm: String(cmIn), x: String(cmIn), pcm: around(p).toFixed(1), c: around(p).toFixed(1), n: p.n, mm: Math.round(g * 10 / Math.PI) }; };
      if (cmIn < around(first) - 1) { this._found = first.n; text = fill(this.strings.findSmall || 'Plug 1 already covers {x} cm. Start there, and stop whenever you’re comfortable.', vars(first)); }
      else if (idx === -1) { this._found = last.n; text = fill(this.strings.findLarge || 'Plug 7, at 13.8 cm, is the largest in the kit and sits above 97 in 100 partners.', vars(last)); }
      else { var hit = this.plugs[idx]; this._found = hit.n; text = fill(this.strings.findMatch || 'Your goal is plug {n}. Its Peak is {c} cm around, the closest step at or above {x} cm.', vars(hit)); }
      if (msg) msg.textContent = text;
      if (go) { go.hidden = false; go.textContent = fill(this.strings.findButton || 'Show me plug {n}', { n: this._found }); }
    }
  }
  if (!customElements.get('pace-size-explorer')) customElements.define('pace-size-explorer', PaceSizeExplorer);

  class PaceStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.bar = this.querySelector('.pace-sticky');
      this.btn = this.querySelector('[data-sticky-add]');
      this.variantEl = this.querySelector('[data-sticky-variant]');
      var find = function () {
        return document.querySelector('product-form-component button[name="add"]') ||
          document.querySelector('form[action*="/cart/add"] button[type="submit"]');
      };
      this.main = find();
      if (!this.main || !this.bar) return;
      if ('IntersectionObserver' in window) {
        var footer = document.querySelector('footer, .shopify-section-group-footer-group');
        var mainVisible = true, footerVisible = false;
        var update = function () { self.bar.classList.toggle('is-visible', !mainVisible && !footerVisible && window.scrollY > 200); };
        new IntersectionObserver(function (es) { es.forEach(function (e) { mainVisible = e.isIntersecting || e.boundingClientRect.top > 0; }); update(); }).observe(this.main);
        if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { footerVisible = e.isIntersecting; }); update(); }).observe(footer);
      }
      this.btn.addEventListener('click', function () {
        var main = find();
        if (!main) return;
        if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        main.click();
      });
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('variant-picker input, variant-picker select')) {
          setTimeout(function () { self.syncVariant(); }, 50);
        }
      });
      this.syncVariant();
    }

    syncVariant() {
      if (!this.variantEl) return;
      var checked = document.querySelector('variant-picker input[type="radio"]:checked');
      var sel = document.querySelector('variant-picker select');
      var val = checked ? checked.value : (sel ? sel.value : '');
      if (val) this.variantEl.textContent = val;
      var main = document.querySelector('product-form-component button[name="add"]');
      if (main && this.btn) this.btn.disabled = !!main.disabled;
    }
  }
  if (!customElements.get('pace-sticky-atc')) customElements.define('pace-sticky-atc', PaceStickyAtc);
})();
